// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1HE6t","rootSuccess":"CompleteLink_rootSuccess__11h7w","rootFailure":"CompleteLink_rootFailure__2rM7n","isDisabled":"CompleteLink_isDisabled__3Mctq"};